import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=3ab2b927&scoped=true"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=3ab2b927&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2b927",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab2b927')) {
      api.createRecord('3ab2b927', component.options)
    } else {
      api.reload('3ab2b927', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=3ab2b927&scoped=true", function () {
      api.rerender('3ab2b927', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/balance.vue"
export default component.exports